export const name = 'interactions' as const

export const HasInteractionsRegistrySym = Symbol('HasInteractionsRegistry')
